
export const BASEURL = 'https://cfanback.agdatagh.com/v1/';
